import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/style/main-style.css'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

import App from './App.vue'
import router from './router'
import { msal } from "@/services/msal-config";


const bootstrap = async () => {
  await msal.initialize()
  const maybeAccountInfo = await msal.handleRedirectPromise();
  // removes params from redirect url
  const url = new URL(window.location.href);
  url.search = ""; // Remove all query parameters
  window.history.replaceState({}, document.title, url.pathname);

  const app = createApp(App)

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }

  app.use(createPinia())
  app.use(ElementPlus)
  app.use(router)

  await redirectToOriginalUrl()

  app.mount('#app')
}

// TODO: I don't like this, need to switch to doing this in router, but it doesn't work right away, some changes
//    to when we call authentication might be required
//    If we switch to the router - we might remove the login button and just invoke auth when we navigate to some
//      route and we don't have an active account, this way we will get rid of a redundant manual step - clicking login
//    The snippet below is only a suggestion, it won't work as is - login will go into a loop
// router.beforeEach(async (to, from, next) => {
//   const account = msal.getActiveAccount();
//
//   if (!account) {
//     sessionStorage.setItem("redirectAfterLogin", to.fullPath);
//     await useAuth().login();
//   } else {
//     next();
//   }
// });
const redirectToOriginalUrl = async () => {
  // If we pasted an url which lead us to the login flow, here we set router back to the route from the original url
  const redirectAfterLogin = sessionStorage.getItem("redirectAfterLogin");
  if (redirectAfterLogin) {
    await router.push(redirectAfterLogin)
    sessionStorage.removeItem("redirectAfterLogin");
  }
}

bootstrap();
